// removed by extract-text-webpack-plugin
module.exports = {"scope":"_3IEa5UrDhCWQZ5FkEYAj7u","content":"_2wypS4FVSaMGx2ncLo0nno","ratio1x1":"WwRMnH5jzvGqwfuL-o_K4","ratio2x1":"lC5xOeTmheiSpGJdZb0ez","ratio3x1":"_1V8-Ev8M9eJNOWDLhOPBXI","ratio15x1":"_1lAWueyyGCuETBW2s36zsK","center":"_1W97a7wFYgpuuChH985aRu","top":"qbHmeUJOtNBNwG2Hi_xuG","bottom":"_2bofnFTdllFjTLQo5sPEkv","container":"_3jaGhJQ86GdKCSdYlRvC4v"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/AspectRatio/style.css
// module id = 406
// module chunks = 39